/**
 *
 * Menu
 *
 */

import React, { useRef } from 'react';
import './Menu.scss';

import { useEffect } from 'react';
import { useLocation } from 'react-router';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from './MenuItem';
import Menu from '@material-ui/core/Menu';

const NavMenu = ({ isMobile = false, mobileOpen, handleCloseMenu, handleClose, handleLogout, ...rest }) => {
  let location = useLocation();
  const menuRef = useRef();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenu = () => {
    if (isMobile) {
      handleCloseMenu();
    }
  };

  const handleBackdropClick = (event) => {
    try {
      if (menuRef && menuRef.current.contains(event.target)) {
        return;
      }
      handleMenu();
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (isMobile && mobileOpen) {
      document.addEventListener('click', handleBackdropClick);
    }
    return function cleanup() {
      document.removeEventListener('click', handleBackdropClick);
    };
  }, [isMobile, mobileOpen]);

  return (
    <div className={`menu-wrapper ${isMobile ? `mobile-view ${mobileOpen && 'mobile-open'}` : ''}`} ref={menuRef}>
      <IconButton className="menu-icon-wrapper" onClick={() => handleMenu()}>
        <MenuIcon htmlColor="#FFFFFF" />
      </IconButton>
      <MenuItem location={location.pathname} handleLogout={handleLogout} isMobile />
    </div>
  );
};

export default NavMenu;
